/*!

 * DH Commerce OS v1.4

 * dh-commerce-config.js

 *

 * Store configuration layer.

 *

 * This file is intentionally data-driven. It contains store-specific settings,

 * selectors, catalogs, relationships, placements, offers, recommendation rules,

 * experiments, and startup options. It contains no engine implementation.

 *

 * Copy this file for each Shopify storefront and change only configuration data.

 */

(function (window, document) {

  "use strict";

 

  var ROOT = window.DHCommerce = window.DHCommerce || {};

  var VERSION = "1.4.0";

 

  function isPlainObject(value) {

    return Object.prototype.toString.call(value) === "[object Object]";

  }

 

  function clone(value) {

    if (Array.isArray(value)) return value.map(clone);

    if (isPlainObject(value)) {

      var result = {};

      Object.keys(value).forEach(function (key) { result[key] = clone(value[key]); });

      return result;

    }

    return value;

  }

 

  function merge(target) {

    var output = isPlainObject(target) ? clone(target) : {};

    for (var i = 1; i < arguments.length; i += 1) {

      var source = arguments[i];

      if (!isPlainObject(source)) continue;

      Object.keys(source).forEach(function (key) {

        var incoming = source[key];

        if (isPlainObject(incoming) && isPlainObject(output[key])) {

          output[key] = merge(output[key], incoming);

        } else {

          output[key] = clone(incoming);

        }

      });

    }

    return output;

  }

 

  function freezeDeep(value) {

    if (!value || typeof value !== "object" || Object.isFrozen(value)) return value;

    Object.keys(value).forEach(function (key) { freezeDeep(value[key]); });

    return Object.freeze(value);

  }

 

  var DEFAULTS = {

    meta: {

      id: "dh-commerce-store",

      name: "DH Commerce Store",

      version: VERSION,

      environment: "production",

      currency: "USD",

      locale: "en-US",

      timezone: "America/Chicago"

    },

 

    runtime: {

      enabled: true,

      debug: false,

      strictDependencies: false,

      failOpen: true,

      startupTimeoutMs: 10000,

      engineTimeoutMs: 5000,

      rehydrateOnShopifySectionLoad: true,

      observeDom: true,

      autoStart: true,

      startupEvent: "DOMContentLoaded",

      consentRequired: false

    },

 

    engines: {

      rules: { enabled: true, required: false },

      offers: { enabled: true, required: false },

      personalization: { enabled: true, required: false },

      recommendations: { enabled: true, required: false },

      experiments: { enabled: true, required: false },

      ui: { enabled: true, required: false },

      analytics: { enabled: true, required: false }

    },

 

    storage: {

      namespace: "dhcommerce",

      profileKey: "profile",

      experimentKey: "experiments",

      sessionKey: "session",

      cartKey: "cart",

      localTtlMs: 31536000000,

      sessionTtlMs: 86400000

    },

 

    endpoints: {

      cartAdd: "/cart/add.js",

      cartChange: "/cart/change.js",

      cartUpdate: "/cart/update.js",

      cart: "/cart.js",

      recommendations: null,

      analytics:
        "https://ovcqgurzercvxvjlijnz.supabase.co/functions/v1/collect-commerce-event",

      dashboard:
        "https://ovcqgurzercvxvjlijnz.supabase.co/functions/v1/get-commerce-dashboard"

    },

 

    selectors: {

      root: "[data-dh-commerce]",

      product: "[data-dh-product-id]",

      variant: "[data-dh-variant-id]",

      category: "[data-dh-category-id]",

      placement: "[data-dh-placement]",

      offer: "[data-dh-offer-id]",

      experiment: "[data-dh-experiment-id]",

      addToCart: "[data-dh-add-to-cart]",

      cartDrawer: "[data-dh-cart-drawer]",

      cartCount: "[data-dh-cart-count]",

      cartSubtotal: "[data-dh-cart-subtotal]",

      loading: "[data-dh-loading]",

      error: "[data-dh-error]"

    },

 

    attributes: {

      productId: "data-dh-product-id",

      variantId: "data-dh-variant-id",

      categoryId: "data-dh-category-id",

      placementId: "data-dh-placement",

      offerId: "data-dh-offer-id",

      recommendationId: "data-dh-recommendation-id",

      experimentId: "data-dh-experiment-id",

      action: "data-dh-action"

    },

 

    classes: {

      active: "is-active",

      hidden: "is-hidden",

      disabled: "is-disabled",

      loading: "is-loading",

      ready: "is-ready",

      error: "has-error",

      qualified: "is-qualified",

      disqualified: "is-disqualified"

    },

 

    catalog: {

      products: [],

      categories: [],

      variants: [],

      collections: []

    },

 

    relationships: {

      crossSell: {},

      related: {},

      substitutes: {},

      complements: {},

      categoryAffinity: {},

      flavorAffinity: {}

    },

 

    rules: [],

    offers: [],

    recommendations: [],

    experiments: [],

 

    placements: {

      definitions: [],

      defaults: {

        recommendationLimit: 4,

        emptyBehavior: "hide",

        loadingBehavior: "preserve",

        renderMode: "replace"

      }

    },

 

    campaigns: {

      parameters: ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"],

      definitions: []

    },

 

    cart: {

      filterAlreadyInCart: true,

      refreshAfterMutation: true,

      optimisticUi: false,

      defaultQuantity: 1,

      sections: []

    },

 

    analytics: {
  enabled: true,
  endpoint:
    "https://ovcqgurzercvxvjlijnz.supabase.co/functions/v1/collect-commerce-event",
      sampleRate: 1,

      includeContext: true,

      includeProfile: false,

      queueOffline: true,

      events: {

        startup: "commerce-started",

        error: "commerce-error",

        recommendation: "recommendation-generated",

        offer: "offer-evaluated",

        experimentExposure: "experiment-exposed",

        conversion: "commerce-conversion"

      }

    },

 

    privacy: {

      respectDoNotTrack: true,

      allowLocalStorage: true,

      allowSessionStorage: true,

      allowCookies: false,

      redactQueryParameters: [],

      consentEvent: "dhcommerce:consent"

    },

 

    ui: {

      enabled: true,

      renderOnStart: true,

      hydrateExistingMarkup: true,

      observeMutations: true,

      mutationDebounceMs: 75,

      animationDurationMs: 220,

      accessibility: {

        announceChanges: true,

        restoreFocus: true,

        trapOverlayFocus: true,

        reducedMotion: "auto"

      }

    },

 

    hooks: {

      beforeStart: [],

      afterStart: [],

      beforeHydrate: [],

      afterHydrate: [],

      onError: []

    }

  };

 

  /*

   * STORE OVERRIDES

   * --------------------------------------------------------------------------

   * Keep the framework generic. Populate the arrays and maps below with each

   * storefront's actual products, categories, relationships, offers and rules.

   */

  var STORE = {

    meta: {

      id: "protein-snack-shop",

      name: "Protein Snack Shop",

      version: VERSION

    },

 

    /* Example catalog record shape (disabled examples only):

     * {

     *   id: "product-handle-or-gid",

     *   handle: "product-handle",

     *   title: "Product Title",

     *   categoryIds: ["cookies"],

     *   tags: ["high-protein", "gluten-free"],

     *   flavors: ["chocolate"],

     *   variantIds: [123456789],

     *   available: true,

     *   price: 0,

     *   metadata: {}

     * }

     */

    catalog: {

      products: [],

      categories: [],

      variants: [],

      collections: []

    },

 

    relationships: {

      crossSell: {},

      related: {},

      substitutes: {},

      complements: {},

      categoryAffinity: {},

      flavorAffinity: {}

    },

 

    /* Engine definitions remain empty until registered by configuration. */

    rules: [],

    offers: [],

    recommendations: [],

    experiments: [],

 

    placements: {

      definitions: []

    },

 

    campaigns: {

      definitions: []

    }

  };

 

  var resolved = merge(DEFAULTS, STORE, window.DHCommerceConfigOverride || {});

 

  var API = {

    version: VERSION,

    initialized: true,

 

    get: function (path, fallback) {

      if (!path) return clone(resolved);

      var parts = Array.isArray(path) ? path : String(path).split(".");

      var cursor = resolved;

      for (var i = 0; i < parts.length; i += 1) {

        if (cursor == null || !Object.prototype.hasOwnProperty.call(cursor, parts[i])) {

          return fallback;

        }

        cursor = cursor[parts[i]];

      }

      return clone(cursor);

    },

 

    has: function (path) {

      var marker = {};

      return this.get(path, marker) !== marker;

    },

 

    all: function () {

      return clone(resolved);

    },

 

    extend: function (overrides) {

      if (!isPlainObject(overrides)) throw new TypeError("Config.extend expects an object.");

      resolved = merge(resolved, overrides);

      return this.all();

    },

 

    replace: function (nextConfig) {

      if (!isPlainObject(nextConfig)) throw new TypeError("Config.replace expects an object.");

      resolved = merge(DEFAULTS, nextConfig);

      return this.all();

    },

 

    validate: function () {

      var errors = [];

      var warnings = [];

      if (!resolved.meta || !resolved.meta.id) errors.push("meta.id is required");

      if (!resolved.meta || !resolved.meta.version) errors.push("meta.version is required");

      if (!resolved.engines || !isPlainObject(resolved.engines)) errors.push("engines must be an object");

      if (!resolved.catalog || !Array.isArray(resolved.catalog.products)) errors.push("catalog.products must be an array");

      if (!resolved.selectors || !resolved.selectors.root) warnings.push("selectors.root is not configured");

      if (resolved.runtime && resolved.runtime.debug && resolved.meta.environment === "production") {

        warnings.push("debug is enabled in production");

      }

      return { valid: errors.length === 0, errors: errors, warnings: warnings };

    },

 

    snapshot: function () {

      return freezeDeep(clone(resolved));

    }

  };

 

  ROOT.config = API;

  ROOT.configuration = API;

 

  try {

    document.dispatchEvent(new CustomEvent("dhcommerce:config-ready", {

      detail: { version: VERSION, store: resolved.meta.id, config: API.snapshot() }

    }));

  } catch (error) {

    /* CustomEvent can be unavailable in extremely old environments. */

  }

 

})(window, document);